import Markdown from "@/components/atoms/Markdown";
import styles from "./styles.module.scss";
import { useMemo } from "react";
import strapiSingleAttribute from "@/api/strapiSingleAttribute";

export default function FacultyCardWithDescription({
  Name,
  ShortDesc,
  Department,
  Designation,
  Picture,
}) {
  const img = useMemo(() => {
    return strapiSingleAttribute(Picture?.source || Picture);
  }, [Picture?.source]);
  return (
    <div className={styles.root}>
      <div className={styles.container}>
        <Markdown className={styles.desc}>{`“${ShortDesc}”`}</Markdown>

        <div>
          <Markdown as="h3" className={styles.name}>{Name}</Markdown>
          <p className={styles.dept}>
            {Department ? `Department of ${Department},` : ""}
            {Designation}
          </p>
        </div>
      </div>
      <img
        src={img?.url}
        alt={img?.alternativeText || 'Faculty Image'}
        className={styles.img}
        loading="lazy"
        title="Faculty Image"
      />
    </div>
  );
}
